if ( typeof EnrollmentForm !== 'function' ) {

	class EnrollmentForm extends HTMLElement {

		constructor(){
			super();

      this.modal = this.closest('[data-enrollment-locator-modal]');
      this.modalContent = this.modal.querySelector('[data-enrollment-locator-modal-content]');
      this.inputs = this.querySelectorAll('[data-enrollment-form-input]');
      this.error = this.querySelector('[data-enrollment-form-error]');
      this.submit = this.querySelector('[data-enrollment-form-submit]');

      this.areaCodeEl = this.querySelector('[data-enrollment-form-area-code]');
      this.areaCodeAttr = this.areaCodeEl.getAttribute('data-enrollment-form-area-code');
      this.areaCode = (this.areaCodeAttr && this.areaCodeAttr !== '') ? this.areaCodeAttr : '+593';

      this.init();
		}

    init() {
      this.submit.addEventListener('click', this.onEnrollmentFormSubmit.bind(this));
    }

    async onEnrollmentFormSubmit() {
      const isValid = this.validateEnrollmentForm();
      if (!isValid) {
        this.showMissingInputsError();
        return;
      }

      const formData = Array.from(this.inputs)
        .reduce((prev, curr) => {
          let value = curr.value;
          let type = curr.getAttribute('data-enrollment-form-input');
          if (type === 'phone' && this.areaCode) {
            value = `${this.areaCode}${curr.value}`
          }
          return { ...prev, [curr.getAttribute("name")]: value }
      }, {});

      this.submit.setAttribute('disabled', 'disabled');
      this.submit.classList.add('loading');

      try {
        this.customer = await window.backend.createEnrollmentCustomer(formData);
        
        this.submit.classList.remove('loading');
        this.submit.classList.add('has-success');

        setTimeout(async () => {
          this.submit.removeAttribute('disabled');
          this.submit.classList.remove('has-success');

          this.renderState('default-form', 'post-form');
        }, 1500);
      } catch (e) {
        this.showError(e); 

        this.submit.removeAttribute('disabled');
        this.submit.classList.remove('loading');

        console.error(e);
      }
    }

    validateEnrollmentForm() {
      var valid = false;
  
      Array.from(this.inputs).every((input) => {
        valid = input.checkValidity();
        return valid;
      });
  
      return valid;
    }

    showMissingInputsError() {
      this.error.textContent = window.theme.strings.enrollment.missingFieldsError;
      this.classList.add("has-error");
    }
  
    showError(error) {
      let data = null;
      try {
        data = JSON.parse(error.message);
      } catch {}
  
      let errorMessage = "";
      if (data && data.error) {
        errorMessage = data.error;
      }

      this.error.textContent =
        errorMessage === "Email is invalid"
          ? theme.strings.enrollment.invalidEmailError
          : errorMessage === "Email has already been taken"
          ? theme.strings.enrollment.emailInUseError
          : errorMessage === "Enter a valid phone number"
          ? theme.strings.enrollment.invalidPhoneError
          : errorMessage === "Phone has already been taken"
          ? theme.strings.enrollment.phoneInUseError
          : theme.strings.enrollment.generalError;
      this.classList.add("has-error");
    }

    renderState(prev, curr) {
      this.modalContent.classList.remove(prev);
      this.modalContent.classList.add(curr);
      this.modalContent.setAttribute('data-enrollment-locator-modal-content', curr);
    }
	}

  if ( typeof customElements.get('enrollment-form') == 'undefined' ) {
    customElements.define('enrollment-form', EnrollmentForm);
	}

}